import { generateKeyBetween } from 'fractional-indexing';
/**
 * Fractional index keys for sibling order (docs/08 §8). Keys compare bytewise, which is why
 * `sort_key` is `COLLATE "C"` in Postgres and plain `text` in SQLite.
 */
/** Key that sorts after `last` (or the first key when there are no siblings). */
export function sortKeyAfter(last) {
    return generateKeyBetween(last, null);
}
/** Key strictly between two neighbours (either may be null at the edges). */
export function sortKeyBetween(before, after) {
    return generateKeyBetween(before, after);
}
//# sourceMappingURL=sort-keys.js.map